import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

// Sample financial data
// const financialData = [
//   {
//     Month: "2025-02",
//     Income: 231045.56,
//     Expense: 0,
//     NetProfit: 231045.56,
//     ProfitPercent: 100,
//   },
//   {
//     Month: "2025-03",
//     Income: 136589.28,
//     Expense: 500,
//     NetProfit: 136089.28,
//     ProfitPercent: 99.63,
//   },
//   {
//     Month: "2025-04",
//     Income: 188793.47,
//     Expense: 0,
//     NetProfit: 188793.47,
//     ProfitPercent: 100,
//   },
//   {
//     Month: "2025-05",
//     Income: 201033.23,
//     Expense: 400.5,
//     NetProfit: 200632.73,
//     ProfitPercent: 99.8,
//   },
//   {
//     Month: "2025-06",
//     Income: 58106.43,
//     Expense: 260.1,
//     NetProfit: 57846.33,
//     ProfitPercent: 99.55,
//   },
//   {
//     Month: "2025-07",
//     Income: 148943.34,
//     Expense: 0,
//     NetProfit: 148943.34,
//     ProfitPercent: 100,
//   },
// ];
const GroupedBarChart = ({endpoint}) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"


  const [financialData, setFinancialData] = useState(null);

  useEffect(() => {
    fetchFinancialData();
  }, []);

    const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two digits for month
    const day = String(today.getDate()).padStart(2, "0"); // Ensure two digits for day
    return `${year}-${month}-${day}`;
  };

  const todayDate = getTodayDate();


  const fetchFinancialData = async () => {
    try {
      const response = await axios.get(
        `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/MAIN/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
      );
      const data = response.data;
      console.log("financial data", data);
      setFinancialData(data);
    } catch (err) {
      console.error("Error while fetching financial data", err);
    }
  };
    

  return (
    <div className="w-full h-[400px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={financialData}
          margin={{ top: 20, right: 30, left: 10, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="Month" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Income" fill="#3B82F6" name="Income" />
          <Bar dataKey="Expense" fill="#EF4444" name="Expense" />
          <Bar dataKey="NetProfit" fill="#22C55E" name="Net Profit" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GroupedBarChart;